import { Link } from 'react-router-dom';
import { works } from '@/mocks/films';

const entries = [
  {
    type: 'movie' as const,
    title: '电影',
    desc: '院线新片、经典佳作与类型片单',
    icon: 'ri-film-line',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20movie%20theater%20with%20rows%20of%20warm%20seats%20and%20glowing%20screen%2C%20dramatic%20amber%20lighting%2C%20elegant%20minimal%20artistic%20rendering%20without%20text&width=900&height=600&seq=home-cat-movie&orientation=landscape',
  },
  {
    type: 'tv' as const,
    title: '电视剧',
    desc: '热播剧集、口碑长剧与季播新番',
    icon: 'ri-live-line',
    image:
      'https://readdy.ai/api/search-image?query=cozy%20living%20room%20at%20night%20with%20a%20glowing%20television%20and%20soft%20warm%20lamp%20light%2C%20artistic%20minimal%20render%2C%20inviting%20atmosphere%20without%20text&width=900&height=600&seq=home-cat-tv&orientation=landscape',
  },
];

export default function CategoryEntry() {
  const countOf = (t: 'movie' | 'tv') => works.filter((w) => w.type === t).length;

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-8 md:py-14">
        <div className="mb-6 flex items-end justify-between">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              分类快捷入口
            </h2>
            <p className="mt-2 text-sm text-foreground-500">按作品形态快速找到你想看的类型</p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
          {entries.map((entry) => (
            <Link
              key={entry.type}
              to={`/category/${entry.type}`}
              className="group relative overflow-hidden rounded-lg border border-background-200"
            >
              <div className="relative h-44 w-full md:h-56">
                <img
                  src={entry.image}
                  alt={`${entry.title}分类`}
                  title={`${entry.title}影视作品集合`}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/35 to-transparent" />
              </div>
              <div className="absolute inset-0 flex flex-col justify-end p-5 text-background-50 md:p-6">
                <div className="flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                    <i className={`${entry.icon} text-xl`} />
                  </span>
                  <div>
                    <h3 className="font-heading text-xl font-bold">{entry.title}</h3>
                    <p className="text-xs text-background-50/80">
                      共 {countOf(entry.type)} 部作品
                    </p>
                  </div>
                </div>
                <p className="mt-3 text-sm text-background-50/80">{entry.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-accent-300">
                  进入分类
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}